import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSimulador } from '../Context_simulador/simulador_context';
import { getBottomNavigationItems, isNavigationItemActive } from './navigationConfig';
import { useTranslation } from 'react-i18next';

function BottomNavigation() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const { systemMode } = useSimulador();
  const navItems = getBottomNavigationItems(systemMode);

  return (
    <div className="app-bottom-nav-wrap">
      <nav className="app-bottom-nav" aria-label={t('navigation.main')}>
        {navItems.map((item) => {
          const isActive = isNavigationItemActive(item, location.pathname);
          return (
            <NavLink
              key={item.id}
              to={item.path}
              aria-current={isActive ? 'page' : undefined}
              data-nav-item={item.id}
              className={`app-bottom-nav__item${isActive ? ' app-bottom-nav__item--active' : ''}`}
            >
              <img src={item.resolvedIcon} alt="" className="app-bottom-nav__icon" />
              <span className="app-bottom-nav__label">{t(item.labelKey)}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}

export default React.memo(BottomNavigation);
